{
  "leftBg": "assets/front/img/login/Login-left-rectangleimage.png",
  "blueLogo": "assets/front/img/login/SPOVIX_Blue.svg",
  "racingCar": "assets/front/img/login/login-racing-car.png",
  "captchaEye": "assets/front/img/re-captcha.svg",
  "lock": "assets/front/img/login/auth-lock.png",
  "mail": "assets/front/img/login/auth-mail.png",
  "verify": "assets/front/img/login/auth-verify.png",
  "expired": "assets/front/img/login/auth-link-expired.png"
}
